<template>
  <BInputGroup class="flex-nowrap"
               :size="BootstrapVariant.SMALL">
    <BInputGroupPrepend is-text>
      <Icon :title="tr('common.SEARCH')"
            class="px-2"
            name="search"></Icon>
    </BInputGroupPrepend>
    <BFormInput v-model="searchTerm"
                class="d-inline-block h-100"
                name="search"
                :placeholder="placeholder"
                type="text"></BFormInput>
    <BInputGroupAppend>
      <ButtonIconOnly :title="tr('javascript.TX_REMOVE')"
                      :variant="BootstrapVariant.SECONDARY"
                      class="reset-button"
                      icon-name="cross2"
                      @click="clear"></ButtonIconOnly>
    </BInputGroupAppend>
  </BInputGroup>
</template>

<script>
  import {
    BInputGroup, BInputGroupPrepend, BInputGroupAppend, BFormInput,
  } from 'bootstrap-vue';
  import { translator } from '~/zf/frontend/common/mixins';
  import BootstrapVariant from '~/zf/frontend/vendor/bootstrap/BootstrapVariant';
  import FilterId from '~/zf/frontend/common/ag-grid/const/FilterId';
  import ButtonIconOnly from '../../layout/ButtonIconOnly.vue';
  import Icon from '../../layout/Icon.vue';

  export default {
    name: 'TextFilter',
    compatConfig: {
      MODE: 3,
      COMPONENT_FUNCTIONAL: true,
    },
    components: {
      ButtonIconOnly,
      Icon,
      BInputGroup,
      BInputGroupPrepend,
      BInputGroupAppend,
      BFormInput,
    },
    mixins: [
      translator,
    ],
    props: {
      placeholder: {
        type: String,
        default: '',
      },
    },
    emits: ['change'],
    data() {
      return {
        searchTerm: '',
        BootstrapVariant,
      };
    },
    watch: {
      searchTerm(searchTerm) {
        const trimmedSearch = searchTerm.trim();
        const value = trimmedSearch === '' ? undefined : trimmedSearch;
        this.$emit('change', FilterId.SEARCH, value);
      },
    },
    methods: {
      clear() {
        this.searchTerm = '';
      },
      setSearchTerm(search) {
        this.searchTerm = search;
      },
    },
  };
</script>
